import type { VolumeBucket } from "../shared/types";
import { VOLUME_BUCKETS } from "../shared/types";

export { VOLUME_BUCKETS };

export function volumeLabel(v: VolumeBucket) {
  switch (v) {
    case "trace":
      return "Trace";
    case "small":
      return "Small drink";
    case "medium":
      return "Medium";
    case "large":
      return "Big drink";
    case "soak":
      return "Soak";
    default:
      return v;
  }
}
